export const es = {
  links: {
    home: "Página de inicio",
    mission: "Misión",
    services: "Servicios",
    contact: "Contacto",
    privacy: "Política de privacidad",
    paymentPlans: "Planes de Pago",
  },
  contact: {
    title: "Información de contacto",
    findUs: "Encuéntranos",
    btnWhatsapp: "btn_whatsapp_es.png",
    Call: "Llama al 754.752.1888",
    SMS: "Mensaje de texto 754.752.1888",
    WhatsappMsg: "WhatsApp 754.276.1746",
    AfterHours:
      "TENGA EN CUENTA: DESPUÉS DE HORAS Y FINES DE SEMANA - Solo estamos disponibles a través de mensajes de texto en:",
  },
  img: {
    img1: "1_es2.jpg",
    img2: "2_es2.jpg",
  },
  footer: {
    quickLinks: "Enlaces rápidos",
    bookAppointment: "Reservar una cita",
    footerDisclaimer: "Consulta obligatoria. Las recetas se emiten a discreción del proveedor médico según la necesidad clínica. Los resultados pueden variar según la persona.",
    disclaimerHeading: "Información Importante sobre Medicamentos y Servicios",
    compoundedTitle: "Aviso sobre Medicamentos Compuestos (Compounded)",
    compoundedDisclaimer: "Los medicamentos compuestos (compounded) no están aprobados por la FDA y no han sido evaluados por la FDA en cuanto a seguridad, eficacia o calidad.",
    availabilityTitle: "Disponibilidad de Servicios",
    serviceAvailability: "Los servicios presenciales están disponibles en nuestra clínica de Pompano Beach, Florida. Los servicios de telesalud están disponibles para pacientes elegibles ubicados en Florida, Massachusetts, Nueva Jersey, Nueva York y Connecticut, sujeto a la disponibilidad del proveedor y a la ley aplicable.",
    medicalTitle: "Aviso Médico",
    medicalDisclaimer: "La información proporcionada en este sitio web tiene únicamente fines educativos y no pretende sustituir el consejo, diagnóstico o tratamiento médico. Todos los servicios médicos se brindan únicamente después de una consulta individual con un proveedor de atención médica con licencia. Las recomendaciones de tratamiento, incluidos los medicamentos recetados cuando sea clínicamente apropiado, se basan en el historial médico y la evaluación clínica de cada paciente. Los resultados individuales varían y no todos los pacientes son candidatos para todos los tratamientos.",
  },
  altsImgs: {
    btnWhatsapp: "Botón para iniciar chat de WhatsApp.",
    logoDiverse: "Diverse Care Now",
    slide1: "Diapositiva 1",
    slide2: "Diapositiva 2",
  },
  carousel: {
    previous: "Anterior",
    next: "Siguiente",
  },
  modal: {
    title: "Reservar una cita",
    message: "Programe su consulta médica hoy",
    close: "Cerrar",
    bookNow: "Programar Consulta",
  },
  weightLoss: {
    meta: {
      title: "Programa Médico de Pérdida de Peso | Tratamientos Supervisados por Médicos y Planes Personalizados | Diverse Care Now",
    },
    header: {
      bookAppointment: "RESERVAR CITA",
    },
    hero: {
      headline: "Pérdida de Peso Guiada por Médicos con Consultas en Línea y Soporte Clínico Integral.",
      subtitle: "Nuestro Programa Médico de Pérdida de Peso está diseñado para brindar apoyo seguro y supervisado por médicos para el control de peso sostenible.",
      description: "Este programa médico de pérdida de peso combina evaluación clínica, planificación personalizada y orientación de salud metabólica para ayudar a los pacientes a lograr resultados a largo plazo.",
    },
    features: {
      flexibleTitle: "Control de Peso Flexible.",
      flexibleDesc: "Nuestro enfoque clínico se centra en la salud metabólica para apoyar sus objetivos, adaptándose a su estilo de vida y horario.",
      emotionalTitle: "Apoyo para la Alimentación Emocional y los Desafíos Diarios",
      emotionalDesc: "Obtenga coaching en línea estructurado y orientación clínica para ayudar a manejar los hábitos alimenticios y mantener la consistencia.",
      licensedTitle: "Experiencia Médica Licenciada.",
      licensedDesc: "Sin tendencias. Solo planes de tratamiento personalizados con profesionales certificados y gestión experta de recetas.",
    },
    provider: {
      title: "Especialista en Telesalud en Pérdida de Peso y Cuidado de la Longevidad",
      subtitle: "Ayudando a los pacientes a lograr resultados duraderos a través de telemedicina guiada por médicos y pérdida de peso médica.",
      bio1: "Como médica certificada en pérdida de peso médica y longevidad, he ayudado a miles a recuperar el control — no solo sobre el peso, sino sobre la energía, la mentalidad y la salud.",
      bio2: "Por eso creé Diverse Care Now: un programa basado en telemedicina enfocado en ciencia, seguridad y atención médica continua — con planes de atención personalizados y soporte clínico continuo. Utilizamos tratamientos metabólicos basados en evidencia bajo estricta supervisión médica, además de coaching nutricional y seguimiento remoto — sin necesidad de visitas clínicas.",
      missionIntro: "Mi misión es simple:",
      missionText: "Ayudarte a lograr resultados reales a través del apoyo médico — no restricción, sino cuidado inteligente, seguro y dirigido por médicos.",
      bookConsultation: "Reserve Su Consulta",
    },
    stats: {
      count: "9.876+",
      patientsSupported: "Pacientes Apoyados",
      tagline: "Recupere su confianza y brille",
      description: "Atención accesible y basada en evidencia para su viaje de bienestar.",
      proceduresPerformed: "Procedimientos Realizados",
      proceduresDesc: "Procedimientos efectivos, asequibles y resultados duraderos.",
    },
    clinicalSupport: {
      title: "Soporte Clínico Integral para el Bienestar Metabólico a Largo Plazo",
      intro: "Soporte clínico basado en evidencia enfocado en la salud metabólica y hábitos de vida equilibrados.",
      body1: "Los programas avanzados de manejo de peso guiados por médicos se centran en apoyar el bienestar metabólico y los objetivos de salud a largo plazo.",
      body2: "Estos programas están diseñados para apoyar rutinas saludables y bienestar a largo plazo abordando factores relacionados con la conciencia del apetito, la digestión y la salud metabólica general.",
      focusIntro: "Las áreas de enfoque del programa incluyen:",
      focus1: "Conciencia del apetito y patrones alimenticios",
      focus2: "Control de porciones y equilibrio digestivo",
      focus3: "Progreso consistente apoyado por hábitos saludables",
      closing1: "Bajo orientación profesional, los planes de atención integral enfatizan el progreso sostenible y la consistencia, siempre en combinación con hábitos saludables.",
      closing2: "Nuestros programas clínicos priorizan la salud metabólica sostenible a través de orientación profesional.",
    },
    pricing: {
      title: "Soporte Clínico Integral de Peso — Planes de Membresía Disponibles",
      intro: "Atención personalizada y supervisión médica continua, guiada por proveedores licenciados y enfocada en la salud y el equilibrio a largo plazo.",
      body: "Nuestro programa comienza con una evaluación clínica y continúa con seguimiento estructurado diseñado para apoyar el bienestar y los objetivos de salud a largo plazo. Los programas son guiados médicamente y adaptados a perfiles de salud individuales, factores de estilo de vida y objetivos de bienestar a largo plazo.",
      emphasis: "Conciencia de salud metabólica, equilibrio energético y soporte clínico profesional para el bienestar a largo plazo. Esta no es una solución a corto plazo. Es un modelo de atención supervisado médicamente enfocado en el bienestar a largo plazo.",
      basicTitle: "PLAN DE ATENCIÓN BÁSICA – OPCIONES DE MEMBRESÍA",
      premiumTitle: "PLAN DE SOPORTE PREMIUM – ATENCIÓN MENSUAL",
      disclaimer: "La dosificación y los detalles de medicación se determinan después de la evaluación médica. Solo precios ilustrativos. No es garantía de tratamiento o cantidad.",
      premiumDisclaimer: "La dosificación y el tipo de medicación se determinan después de la consulta médica. Solo con fines informativos.",
      contraceptiveNote: "Algunos tratamientos médicos pueden requerir consideraciones adicionales relacionadas con el uso de anticonceptivos. Siempre siga la orientación proporcionada por su profesional de salud e instrucciones del fabricante.",
      contactSupport: "Para preguntas clínicas o atención de seguimiento, comuníquese directamente con Diverse Care Now.",
    },
    careProcess: {
      step1Title: "Consulta Inicial y Evaluación",
      step1Bullet1: "Historial de salud completo y revisión metabólica",
      step1Bullet2: "Plan de atención personalizado alineado con sus objetivos y perfil de salud",
      step2Title: "Programa de Atención Clínica",
      step2Bullet1: "Supervisión profesional y monitoreo clínico",
      step2Bullet2: "Orientación continua del proveedor como parte de un modelo de atención supervisado",
      step3Title: "Coaching de Nutrición y Estilo de Vida",
      step3Bullet1: "Estructura de comidas y apoyo de conciencia de porciones",
      step3Bullet2: "Manejo del estrés y coaching enfocado en el comportamiento",
      step4Title: "Seguimientos y Soporte Continuo",
      step4Bullet1: "Seguimientos regulares por mensaje o video",
      step4Bullet2: "Responsabilidad y continuidad de atención a largo plazo",
      attribution: "Nuestro programa incluye una consulta clínica y un programa de atención estructurado supervisado por médicos guiado por Laura Uchôa y su equipo médico licenciado.",
    },
    nutrition: {
      label: "ORIENTACIÓN NUTRICIONAL.",
      title: "LA BASE DE UN PROGRAMA DE BIENESTAR ESTRUCTURADO",
      subtitle: "Desarrollado por la Dra. Laura Uchôa y su equipo, este marco nutricional personalizado está diseñado para apoyar la consistencia, el equilibrio y el bienestar a largo plazo como parte de un enfoque de atención supervisado médicamente.",
      body: "En Diverse Care Now, la orientación nutricional se proporciona como apoyo estructurado dentro de un programa de atención integral, alineado con preferencias individuales, rutinas y objetivos generales de salud.",
      focus1: "Estructura de comidas y opciones alimenticias equilibradas",
      focus2: "Conciencia de porciones y rutinas alimenticias diarias",
      focus3: "Orientación personalizada alineada con objetivos de bienestar y niveles de actividad",
      closing: "Esta no es una dieta genérica. Es un marco nutricional estructurado diseñado para apoyar hábitos sostenibles y consistencia a largo plazo dentro de un programa supervisado médicamente.",
    },
    testimonials: {
      title: "EXPERIENCIAS DE PACIENTES Y VIAJES COMPARTIDOS",
      intro: "Nuestros pacientes confían en Diverse Care Now para atención personalizada guiada por médicos y comparten sus experiencias personales con nuestra atención clínica.",
      reviewCount: "791 reseñas verificadas de Google",
      reviewScope: "Cubre programas de control de peso, estética y bienestar",
      ratingNote: "Cada calificación refleja nuestro compromiso continuo con la calidad médica, la empatía y el apoyo real",
      disclaimer: "Los resultados pueden variar de persona a persona. Los resultados clínicos dependen de los perfiles de salud individuales y la adherencia al programa",
      voicesTitle: "VOCES DE PACIENTES. ORIENTACIÓN CLÍNICA. VIAJES DE BIENESTAR",
      voicesBody: "Dentro de la clínica, Laura Uchôa y su equipo demuestran cómo la atención personalizada guiada por médicos apoya el equilibrio, la confianza y la salud a largo plazo.",
      reviews: [
        { name: 'Samuel Carvalho', time: 'hace 5 meses', text: 'Este lugar me proporcionó el mejor tratamiento estético. El personal es increíblemente profesional y acogedor.' },
        { name: 'Antonio Pinto', time: 'hace 3 meses', text: 'Simplemente EL MEJOR LUGAR PARA ATENCIÓN MÉDICA. Todo el personal es muy atento, desde la recepción hasta los médicos.' },
        { name: 'Flavio Braga', time: 'hace 6 meses', text: '¡Excelente primera visita! Personal amable, Dra. Laura Uchoa es muy atenta y conocedora de todo.' },
        { name: 'Maria Santos', time: 'hace 2 meses', text: 'La Dra. Uchoa realmente se preocupa por sus pacientes. El enfoque personalizado ha cambiado mi vida.' },
        { name: 'John Davis', time: 'hace 4 meses', text: 'La mejor experiencia de telemedicina que he tenido. El equipo es solidario y la orientación nutricional es práctica.' },
        { name: 'Ana Paula', time: 'hace 1 mes', text: 'Era escéptica sobre los programas virtuales de pérdida de peso, pero Diverse Care Now superó todas mis expectativas.' },
        { name: 'Carlos Mendes', time: 'hace 3 meses', text: 'Servicio profesional de principio a fin. El equipo médico realmente escucha y crea un plan que funciona.' },
        { name: 'Jennifer Lopez', time: 'hace 5 meses', text: 'Experiencia increíble con el programa de control de peso. Perdí 11 kg en 3 meses con orientación médica adecuada.' },
      ],
    },
    comprehensiveApproach: {
      title: "UN ENFOQUE CLÍNICO INTEGRAL CENTRADO EN SU BIENESTAR",
      subtitle: "Cada plan comienza con una evaluación médica integral enfocada en la salud metabólica, el equilibrio general y el bienestar a largo plazo.",
      body: "En Diverse Care Now, la atención es guiada por proveedores licenciados y adaptada a sus objetivos, estilo de vida y perfil de salud actual. Nuestros programas integran supervisión médica, orientación nutricional y planificación de actividad — con soporte continuo diseñado para adaptarse a medida que evolucionen sus necesidades de salud.",
      focus1: "Apoyo para el bienestar metabólico y equilibrio clínico",
      focus2: "Conciencia del apetito y patrones alimenticios",
      focus3: "Equilibrio energético y consistencia diaria",
      focus4: "Progreso sostenible a largo plazo apoyado por hábitos saludables",
      keyMessage: "Esto no es una 'solución rápida'. Es una asociación médica construida alrededor de su salud, su ritmo y bienestar a largo plazo.",
      hipaa: "Cumple con HIPAA",
      boardCertified: "Proveedor Certificado",
      secure: "Envío Seguro y Confidencial",
    },
    clinicalOversight: {
      title: "SUPERVISIÓN CLÍNICA PROFESIONAL Y ATENCIÓN CONTINUA",
      body: "En Diverse Care Now, la supervisión clínica es una parte fundamental de nuestro modelo de atención, proporcionando orientación profesional estructurada a lo largo de su viaje de bienestar. Los seguimientos están estructurados para ayudar a los proveedores a revisar el progreso, abordar preguntas y asegurar que la atención permanezca alineada con las necesidades de salud individuales. Este enfoque enfatiza la continuidad, la supervisión profesional y la comunicación clara a lo largo de la experiencia de atención. Las consultas programadas son parte de un programa clínicamente supervisado dedicado a apoyar sus objetivos de salud y bienestar a largo plazo.",
      credentialsTitle: "ATENCIÓN CLÍNICA DEDICADA Y SOPORTE PROFESIONAL",
      credentialsSubtitle: "Nuestro enfoque se centra en la salud metabólica y el bienestar a largo plazo",
      cred1: "En Diverse Care Now, los programas están diseñados para apoyar la consistencia y la orientación clínica profesional",
      cred2: "Bajo la guía de la Dra. Laura Uchôa, nuestro equipo proporciona atención estructurada diseñada para alinearse con perfiles de salud individuales y prácticas clínicas basadas en evidencia",
      cred3: "Dirigido por la Dra. Laura Uchôa, nuestro equipo proporciona atención estructurada e individualizada diseñada para apoyar objetivos de salud sostenibles con orientación profesional continua y comunicación clara",
      cred4: "Priorizamos protocolos basados en evidencia y apoyo al paciente, asegurando comunicación clara y supervisión profesional a lo largo de su experiencia de atención",
    },
    enrollment: {
      cta1: "Comience con una consulta profesional y evaluación personalizada",
      programsTitle: "PROGRAMAS INTEGRALES DE BIENESTAR CLÍNICO",
      body: "Cada plan de atención comienza con una evaluación médica integral realizada por proveedores licenciados. Las opciones de tratamiento, frecuencia de seguimiento y estructura de atención se determinan individualmente según su perfil de salud, objetivos e historial médico. Toda la atención es supervisada por la Dra. Laura Uchôa y su equipo médico licenciado, con monitoreo continuo para garantizar seguridad, consistencia y soporte a largo plazo. Los detalles específicos del tratamiento, recomendaciones y opciones se discuten solo después de una consulta profesional.",
      cta2: "Comience con una consulta médica para ver si la atención es apropiada para usted",
      consultHeadline: "Discuta si la atención médica es apropiada para sus objetivos de salud",
    },
    fourPillars: {
      title: "Los 4 Pilares Médicos Detrás de la Pérdida de Peso Duradera",
      subtitle: "Un enfoque completo que combina atención clínica, hábitos saludables y supervisión médica continua",
      medicationTitle: "MEDICACIÓN",
      medicationBody: "Los tratamientos supervisados ayudan a regular el apetito, mejorar el metabolismo y apoyar el progreso constante. Cuando son monitoreados por profesionales, siguen siendo una de las herramientas más seguras y efectivas para el peso a largo plazo.",
      medicationLink: "Explore nuestro blog para aprender cómo las terapias supervisadas por médicos funcionan de manera segura",
      behaviorTitle: "Cambios de Comportamiento",
      behaviorBody: "El verdadero cambio comienza con la consistencia diaria. Registrar comidas, mejorar la calidad del sueño y manejar el estrés influyen en cómo el cuerpo responde al tratamiento y los resultados de salud a largo plazo.",
      behaviorLink: "Explore nuestro blog para descubrir cómo los pequeños hábitos crean resultados duraderos",
      activityTitle: "Actividad Física",
      activityBody: "El movimiento fortalece tanto el cuerpo como la mente. Incluso el ejercicio ligero y regular mejora la energía, el estado de ánimo y el metabolismo — apoyando el progreso gradual y constante y un mejor bienestar general.",
      activityLink: "Explore nuestro blog para formas simples y seguras de mantenerse activo todos los días",
      nutritionTitle: "Terapia Nutricional",
      nutritionBody: "La nutrición equilibrada es un componente central de la atención integral. Elegir alimentos ricos en nutrientes ayuda a controlar el hambre, estabilizar el azúcar en sangre y mantener la energía y la salud a largo plazo.",
      nutritionLink: "Explore nuestro blog para menús saludables y guías de nutrición basadas en evidencia",
    },
    calculator: {
      title: "Lo Que Su Peso No Le Dice, Pero Sus Hábitos Sí",
      subtitle: "Su peso es más que un número. Descubra cómo su rutina diaria, metabolismo y nivel de actividad realmente moldean su cuerpo, y qué significa eso para su plan de atención personalizado.",
      sex: "Sexo",
      male: "Masculino",
      female: "Femenino",
      age: "Edad",
      years: "años",
      weight: "Peso",
      lbs: "lbs",
      heightFeet: "Altura pies",
      ft: "pies",
      heightInches: "Altura pulgadas",
      in: "pulg",
      healthGoal: "Objetivo de Salud",
      maintainWeight: "Mantener Peso",
      cut250: "Reducir (-250 kcal)",
      cut500: "Reducción Agresiva (-500 kcal)",
      bulkSlow: "Aumento Lento (+200 kcal)",
      bulkLean: "Aumento Magro (+350 kcal)",
      activityLevel: "Nivel de Actividad",
      sedentary: "Sedentario",
      sedentaryDesc: "Poco o ningún ejercicio (trabajo de escritorio)",
      light: "Ligero",
      lightDesc: "1–3 días/semana ejercicio ligero",
      moderate: "Moderado",
      moderateDesc: "3–5 días/semana ejercicio moderado",
      active: "Activo",
      activeDesc: "6–7 días/semana ejercicio intenso",
      veryActive: "Muy Activo",
      veryActiveDesc: "Ejercicio intenso y trabajo físico",
      extraActive: "Extra Activo",
      extraActiveDesc: "Entrenamiento de nivel atlético o trabajo muy físico",
      advancedToggle: "Avanzado: Estimar % de Grasa Corporal (Marina de EE.UU.)",
      waist: "Cintura",
      waistHint: "Medir a nivel del ombligo (relajado)",
      neck: "Cuello",
      neckHint: "Debajo de la nuez de Adán",
      hip: "Cadera",
      hipHint: "Punto más ancho de las caderas",
      advancedNote: "Los campos de grasa corporal son opcionales. Si se dejan en blanco, no se estimará la grasa corporal",
      calculate: "Calcular resultados",
      reset: "Restablecer todos los campos",
      resultsHeader: "SUS RESULTADOS:",
      bmr: "Tasa Metabólica Basal (TMB)",
      bmi: "Índice de Masa Corporal (IMC)",
      targetCalories: "Ingesta calórica objetivo por día",
      macroBalance: "Balance de Macronutrientes",
      fats: "Grasas",
      protein: "Proteínas",
      carbs: "Carbohidratos",
      bodyFat: "Grasa Corporal",
      fatMass: "Masa Grasa",
      leanMass: "Masa Magra",
      disclaimer: "Contenido educativo solamente. No es consejo médico",
      inches: "pulgadas",
    },
    activityRecs: {
      title: "Pequeños Movimientos. Progreso Real. Resultados a largo plazo",
      subtitle: "No necesita entrenar como un atleta — solo necesita ser consistente. Nuestro equipo médico recomienda hábitos simples y sostenibles que se adapten a su estilo de vida y apoyen resultados duraderos",
      rec1: "2 sesiones semanales de resistencia o entrenamiento de fuerza",
      rec2: "5,000–10,000 pasos diarios — su forma más simple de cardio",
      rec3: "150–300 minutos de movimiento moderado cada semana",
      rec4: "75–150 minutos de actividad de mayor intensidad si disfruta esforzarse más",
      disclaimer: "Se requiere consulta. Las recomendaciones individuales pueden variar",
    },
    faq: {
      label: "Preguntas y Respuestas Pérdida de Peso",
      intro: "Antes de comenzar su tratamiento, es natural tener preguntas. Esto es lo que los pacientes preguntan más — y lo que nuestro equipo médico quiere que sepa",
      q1: "¿Qué son las terapias médicas supervisadas para pérdida de peso?",
      a1: "Son terapias supervisadas por médicos, ahora ampliamente utilizadas como parte de programas seguros de control de peso médico. Están diseñadas para apoyar la conciencia del apetito, el equilibrio metabólico y el bienestar general.",
      q2: "¿Son seguros estos medicamentos?",
      a2: "Son seguros cuando son recetados por un profesional de salud. Los efectos secundarios pueden incluir náuseas o cambios digestivos, que se manejan mediante ajustes de dosis y apoyo médico.",
      q3: "¿Cuánto peso puedo perder?",
      a3: "Algunos notan mejoras tempranas en el apetito y la energía dentro de semanas, mientras que los cambios visibles de peso generalmente aparecen después de 4–8 semanas de tratamiento consistente.",
      q4: "¿Todavía necesito dieta y ejercicio?",
      a4: "Sí, los cambios en el estilo de vida mejoran los resultados y ayudan a mantenerlos. Nuestro coaching está diseñado para hacer esto práctico.",
      q5: "¿Qué tan pronto veré resultados?",
      a5: "Algunos notan mejoras tempranas en el apetito y la energía dentro de semanas, mientras que los cambios visibles de peso generalmente aparecen después de 4–8 semanas de tratamiento consistente.",
    },
    finalCta: {
      headline: "Si está listo para una forma segura, supervisada y personalizada de alcanzar sus objetivos, no una solución rápida, sino un plan médico real que se adapte a su vida cotidiana,",
      headlineBold: "nuestro equipo de Diverse Care Now está listo para guiar su próximo paso.",
      tagline: "No es solo peso. Es su energía, su ritmo, su confianza.",
      body1: "Bajo la guía del equipo médico de Diverse Care Now,",
      body2: "cada plan comienza con un propósito, ayudarle a sentirse en control de su cuerpo nuevamente, con seguridad, ciencia y apoyo en cada paso.",
      speakCta: "Hable con un proveedor y descubra si la terapia médica para pérdida de peso es adecuada para usted.",
      legalDisclaimer: "Nuestro sitio web y anuncios promueven un programa de pérdida de peso guiado por médicos. No vendemos ni anunciamos medicamentos con receta. Todos los tratamientos son supervisados por proveedores médicos licenciados según lo exige la ley.",
    },
    footer: {
      email: "patientcare{'@'}diversecarenow.com",
      phone1: "(754) 752-1888",
      phone2: "17542761746",
      bookAppointment: "Reservar una Cita",
      termsOfUse: "Términos de Uso",
      privacyPolicy: "Política de Privacidad",
      copyright: "Copyright © 2025",
      companyName: "DIVERSE CARE NOW",
      allRights: "Todos los Derechos Reservados.",
      footerDisclaimer: "Consulta obligatoria. Las recetas se emiten a discreción del proveedor médico según la necesidad clínica. Los resultados pueden variar según la persona.",
    },
    bitAssist: {
      call: "Llamar",
      sms: "SMS",
      whatsapp: "Whatsapp",
    },
  },
};
